import ops from '@/assets/js/vuescrollOption';
import Img from "@/assets/images/plan_default.png";
import {stuTutorialList,plan_list} from "@/api/common/api";
import {storageData} from "@/assets/js/storage";
export default {
    data() {
        const memberType=storageData.getUserType();
        return {
            showList: false,
            showEmpty: false,
            memberType,
            ops: ops(),
            page: 1,
            paging: {
                start: 0,
                prePage: 1, // 一页多少条数据
                total: 1, // 总页数
                size: 3, // 页码显示限制
                last: true, // 尾页
                next: true, // 下一页
                first: true, // 首页
                previous: true, // 上一页
                jump: true
            },
            imgSrc: Img,
            res_type: 1,
            list: [],
            req_data: {
                session_type: "",
                search_keywords: "",
            }
        };
    },
    filters: {
        addSrc(src,lastUpdated) {
            return `/uploads/library/${src}.jpg?v=${lastUpdated}`;
        }
    },
    components: {
        "v-icon": () => import("vue-awesome/components/Icon"),
        "yioks-paging": () => import("@/components/Pagination/Page"),
        "tutorial-type": () => import("@/components/Tutorial/tutorial-type"),
        "yioks-empty": () => import("@/components/Tips/Empty"),
        "tutorial-excellent": () => import("@/components/Tutorial/tutorial-excellent"),
    },
    created() {
        const {page,tutorial,keywords} = this.$route.query;
        page && (this.page = page);
        tutorial && (this.$set(this.req_data, "session_type", tutorial));
        keywords && (this.$set(this.req_data, "search_keywords", keywords));
        this.handleRequest();
    },
    methods: {
        reqStuList(is_excellent='') {
            if(this.memberType==='system'||this.memberType==='super'){
                plan_list({...this.req_data, page: this.page, is_excellent})
                    .then((res)=>{
                        // console.log(res);
                        this.handleData(res.data);
                    })
                    .catch((err)=>{
                        console.error(err);
                    });
            }else{
                stuTutorialList({...this.req_data, page: this.page, is_excellent})
                    .then((res)=>{
                        // console.log(res);
                        this.handleData(res.data);
                    })
                    .catch((err)=>{
                        console.error(err);
                    });
            }
        },
        handleData(data) {
            const { status, result } = data;
            if(Number(status) == 0) {
                this.list = result.list;
                this.$set(this.paging, "prePage", result.page.page_size);
                this.$set(this.paging, "total", result.page.total_row);
                this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
                this.showList = Boolean(result.list.length > 0);
                this.showEmpty = !this.showList;
            }
        },
        gotoPage(start) {
            this.page = parseInt(start / this.paging.prePage) + 1;
            this.changeQuery(false);
            this.$refs['vs'].scrollTo({y: 0});
        },
        changeQuery(flag) {
            flag && (this.page = 1);
            const {session_type, search_keywords} = this.req_data;
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: this.page,
                    tutorial: session_type,
                    keywords: search_keywords,
                }
            });
            this.handleRequest();
        },
        imgTutorialErr(e) {
            e.target.src = this.imgSrc;
        },
        hideIcon() {
            this.$set(this.req_data, "search_keywords", "");
            this.search();
        },
        search() {
            this.changeQuery(true);
            this.showList&&this.$refs['vs'].scrollTo({y: 0});
        },
        lookOverDetail(id) {
            // console.log(id);
            this.$router.push({
                path: "tutorial_detail",
                query: {
                    id,
                }
            });
        }
    }
}
